import { useRef, useEffect, useState } from "react";

const steps = [
  {
    num: "01",
    icon: "ri-search-eye-line",
    color: "text-primary",
    bg: "bg-orange-50",
    border: "border-orange-200",
    "secondary-light": "#f97316",
    title: "Entdecken Sie den Preis",
    summary: "Jede Ziehung umfasst eine exklusive Immobilie, die von einem unabhängigen Notar bewertet wurde.",
    details: [
      "Sehen Sie sich die Details an: HD-Fotos, interaktiver Plan, Lage, vollständige Beschreibung.",
      "Der Wert der Immobilie wird durch eine offizielle notarielle Bewertung bescheinigt — keine Überbewertung.",
      "Verschiedene Immobilien werden angeboten: Ferienhäuser am Meer, Zweitwohnsitze, Luxusappartements…",
      "Jeder Gewinn beinhaltet die Notarkosten für die Eigentumsübertragung, die vom Veranstalter übernommen werden.",
    ],
    img: "https://readdy.ai/api/search-image?query=elegant%20person%20browsing%20luxury%20real%20estate%20listings%20on%20modern%20laptop%2C%20sitting%20in%20bright%20minimal%20home%20office%2C%20warm%20natural%20light%2C%20professional%20lifestyle%20photography%2C%20clean%20desk%2C%20coffee%20cup%2C%20architectural%20photos%20on%20screen&width=600&height=400&seq=step1-img&orientation=landscape",
  },
  {
    num: "02",
    icon: "ri-ticket-2-line",
    color: "text-sky-500",
    bg: "bg-sky-50",
    border: "border-sky-200",
    "secondary-light": "#0ea5e9",
    title: "Wählen Sie Ihr Los-Paket",
    summary: "Wählen Sie die Anzahl der Lose, die Sie wünschen. Mehr Lose bedeuten höhere Gewinnchancen.",
    details: [
      "6 verschiedene Pakete verfügbar: von 1 Los bis zu 120 Losen + Bonus.",
      "Der Preis pro Los sinkt bei größeren Paketen — bei maximalem Wert.",
      "Jedes Los weist Ihnen eine eindeutige Nummer zu, die in unserem zertifizierten System registriert ist.",
      "Sie können mehrere Pakete für dieselbe Ziehung kaufen, um Ihre Gewinnchancen zu erhöhen.",
    ],
    img: "https://readdy.ai/api/search-image?query=happy%20person%20choosing%20options%20on%20clean%20modern%20e-commerce%20website%2C%20tablet%20in%20hand%2C%20bright%20living%20room%2C%20casual%20smart%20outfit%2C%20warm%20smile%2C%20lifestyle%20product%20photography%2C%20soft%20daylight&width=600&height=400&seq=step2-img&orientation=landscape",
  },
  {
    num: "03",
    icon: "ri-secure-payment-line",
    color: "text-secondary",
    bg: "bg-emerald-50",
    border: "border-emerald-200",
    "secondary-light": "#10b981",
    title: "Sicher bezahlen",
    summary: "Bezahlen Sie per PayPal, Kreditkarte, SEPA-Überweisung, Klarna, Apple Pay oder Google Pay — in weniger als 2 Minuten.",
    details: [
      "Alle Transaktionen sind 256-Bit SSL-verschlüsselt — Ihre Bankdaten werden niemals gespeichert.",
      "Akzeptierte Zahlungsarten: Visa, Mastercard, PayPal, SEPA, Klarna, Apple Pay, Google Pay.",
      "Sofortige Bestätigung per E-Mail mit Ihren Teilnahmenummern nach Zahlungseingang.",
      "Im Falle einer Absage der Ziehung ist eine vollständige Rückerstattung innerhalb von 5 Werktagen garantiert.",
    ],
    img: "https://readdy.ai/api/search-image?query=secure%20online%20payment%20on%20smartphone%20with%20credit%20card%2C%20clean%20minimal%20desk%2C%20warm%20light%2C%20contactless%20payment%20symbol%2C%20modern%20banking%20app%20interface%2C%20lifestyle%20photography%2C%20trust%20and%20security%20concept&width=600&height=400&seq=step3-img&orientation=landscape",
  },
  {
    num: "04",
    icon: "ri-mail-check-line",
    color: "text-violet-500",
    bg: "bg-violet-50",
    border: "border-violet-200",
    "secondary-light": "#8b5cf6",
    title: "Teilnahmenummern erhalten",
    summary: "Ihre eindeutigen Nummern werden Ihnen innerhalb von 2 Minuten per E-Mail zugesandt. Sie sind auch in Ihrem persönlichen Bereich abrufbar.",
    details: [
      "Jedes Los trägt eine eindeutige 5-stellige Nummer, die zufällig generiert und zertifiziert wird.",
      "Die Bestätigungs-E-Mail enthält Ihre Nummern, das Ziehungsdatum und Ihre Bestellübersicht.",
      "Alle Ihre Lose sind jederzeit in Ihrem persönlichen Bereich einsehbar und abrufbar.",
      "48 Stunden vor dem Ziehungsdatum erhalten Sie eine automatische Erinnerung.",
    ],
    img: "https://readdy.ai/api/search-image?query=person%20happy%20reading%20confirmation%20email%20on%20phone%2C%20bright%20clean%20modern%20kitchen%2C%20casual%20outfit%2C%20natural%20light%2C%20lifestyle%20photography%2C%20notification%20badge%2C%20smiling%20expression&width=600&height=400&seq=step4-img&orientation=landscape",
  },
  {
    num: "05",
    icon: "ri-live-line",
    color: "text-rose-500",
    bg: "bg-rose-50",
    border: "border-rose-200",
    "secondary-light": "#f43f5e",
    title: "Live-Ziehung verfolgen",
    summary: "Die Ziehung wird live übertragen und von einem beeidigten Notar überwacht, für absolute Transparenz.",
    details: [
      "Die Ziehung erfolgt über einen zertifizierten Zufallsalgorithmus in Anwesenheit von Notar Dr. Hans-Peter Schmidt.",
      "Die Gewinnnummer wird live gezogen und sofort auf unserer Website und in den sozialen Medien veröffentlicht.",
      "Alle Teilnehmer erhalten sofort nach Abschluss der Ziehung eine Benachrichtigung per E-Mail und SMS.",
      "Das offizielle Ziehungsprotokoll wird innerhalb von 24 Stunden nach der Veranstaltung online veröffentlicht.",
    ],
    img: "https://readdy.ai/api/search-image?query=excited%20people%20watching%20live%20stream%20on%20large%20screen%20TV%2C%20luxury%20modern%20living%20room%2C%20celebration%20mood%2C%20friends%20together%2C%20warm%20golden%20light%2C%20emotional%20moment%2C%20authentic%20lifestyle%20photography&width=600&height=400&seq=step5-img&orientation=landscape",
  },
  {
    num: "06",
    icon: "ri-key-line",
    color: "text-primary",
    bg: "bg-amber-50",
    border: "border-amber-200",
    "secondary-light": "#f59e0b",
    title: "Preis anfordern",
    summary: "Der Gewinner wird innerhalb von 24 Stunden persönlich kontaktiert. Die Schlüsselübergabe erfolgt innerhalb von 30 Tagen.",
    details: [
      "Der Gewinner wird innerhalb von 24 Stunden nach der Ziehung per Telefon und E-Mail kontaktiert.",
      "Eine rechtliche und notarielle Begleitung für die Eigentumsübertragung wird vom Veranstalter sichergestellt.",
      "Die Immobilie wird frei von Bewohnern und schlüsselfertig übergeben — bezugsfertig oder bereit zur Vermietung.",
      "Alle Kosten im Zusammenhang mit der Übertragung (Notar, Grundbucheintrag) werden von der Dreamify gGmbH übernommen.",
    ],
    img: "https://readdy.ai/api/search-image?query=happy%20family%20receiving%20house%20keys%20from%20real%20estate%20agent%2C%20bright%20sunny%20day%2C%20luxury%20villa%20entrance%2C%20emotional%20celebration%20moment%2C%20authentic%20lifestyle%20photography%2C%20warm%20colors%2C%20genuine%20joy&width=600&height=400&seq=step6-img&orientation=landscape",
  },
];

function StepCard({ step, index }: { step: typeof steps[0]; index: number }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const isEven = index % 2 === 0;

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.15 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center transition-all duration-700 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      }`}
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      {/* Image — alternates sides */}
      <div className={`${isEven ? "lg:order-1" : "lg:order-2"} relative rounded-2xl overflow-hidden`} style={{ minHeight: 280 }}>
        <img src={step.img} alt={step.title} className="w-full h-full object-cover" style={{ minHeight: 280 }} />
        {/* Step number overlay */}
        <div className="absolute top-4 left-4">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center text-white font-black text-sm shadow-lg"
            style={{ background: step["secondary-light"] }}>
            {step.num}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className={`${isEven ? "lg:order-2" : "lg:order-1"} flex flex-col gap-5`}>
        <div className="flex items-center gap-3">
          <div className={`w-12 h-12 ${step.bg} ${step.border} border rounded-xl flex items-center justify-center flex-shrink-0`}>
            <i className={`${step.icon} text-xl ${step.color}`}></i>
          </div>
          <span className={`text-xs font-bold uppercase tracking-widest ${step.color}`}>Schritt {step.num}</span>
        </div>

        <div>
          <h3 className="font-playfair text-2xl md:text-3xl font-bold text-slate-900 mb-2 leading-tight">
            {step.title}
          </h3>
          <p className="text-slate-500 text-base leading-relaxed">{step.summary}</p>
        </div>

        <ul className="space-y-3">
          {step.details.map((d, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${step.bg}`}>
                <i className={`ri-check-line text-xs ${step.color}`}></i>
              </span>
              <span className="text-slate-600 text-sm leading-relaxed">{d}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function HowSteps() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-20">
          <span className="uppercase text-secondary-light text-xs font-bold tracking-widest">Vollständiger Prozess</span>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-slate-900 mt-2 mb-4">
            Von A bis Z, in aller Transparenz
          </h2>
          <p className="text-slate-500 max-w-xl mx-auto leading-relaxed">
            Jeder Schritt ist so konzipiert, dass er einfach, schnell und absolut sicher ist — von Ihrem ersten Klick bis zur Schlüsselübergabe.
          </p>
        </div>

        <div className="space-y-24">
          {steps.map((step, i) => (
            <StepCard key={step.num} step={step} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
